import $ from 'jquery'
import { debounce } from './helpers'

$('.header-menu-right [href="/search"]').on('click', function (e) {
  e.preventDefault()
  $('.search-overlay').addClass('search-overlay--active')
  $('.search-overlay [name="q"]').trigger('focus')
})

$('.search-overlay-close-button').on('click', function () {
  $('.search-overlay').removeClass('search-overlay--active')
})

$('.search-overlay [name="q"]').on(
  'keyup',
  debounce(async function () {
    const query = $(this).val()

    await fetchProducts(query)
    await fetchJournal(query)
    $('.search-overlay-results').addClass('search-overlay-results--active')
  }, 300)
)

async function fetchProducts(query) {
  // Build url
  const url = `/search?q=${query}&type=product`

  // Fetch the page
  const res = await fetch(url)
  const text = await res.text()
  const html = document.createElement('div')
  html.innerHTML = text

  // Update count
  const count = Number(html.querySelector('#search-results-count')?.getAttribute('data-count'))
  $('.search-overlay-results-products .results-count').text(count)

  // Update view all link
  $('.search-overlay-results-products .results-view').attr('href', url)

  // Populate products
  $('.search-overlay-product-results').empty()

  if (count > 0) {
    $('.search-overlay-product-results-none').hide()

    const blocks = html.querySelectorAll('.product-grid-item')

    for (var i = 0; i < 3; i++) {
      if (blocks[i]) {
        $('.search-overlay-product-results').append(blocks[i])
      }
    }
  } else {
    $('.search-overlay-product-results-none').show()
  }
}

async function fetchJournal(query) {
  // Build url
  const url = `/search?q=${query}&type=article`

  // Fetch the page
  const res = await fetch(url)
  const text = await res.text()
  const html = document.createElement('div')
  html.innerHTML = text

  // Update count
  const count = Number(html.querySelector('#search-results-count')?.getAttribute('data-count'))
  $('.search-overlay-results-journal .results-count').text(count)

  // Update view all link
  $('.search-overlay-results-journal .results-view').attr('href', url)

  // Populate ul
  $('.search-overlay-journal-results ul').empty()

  if (count > 0) {
    $('.search-overlay-journal-results-none').hide()

    const blocks = html.querySelectorAll('.article-grid-item')

    for (var i = 0; i < 9; i++) {
      const block = blocks[i]

      if (block) {
        const title = block.querySelector('h2').textContent
        const href = block.getAttribute('href')

        $('.search-overlay-journal-results ul').append(`<li><a href="${href}">${title}</a></li>`)
      }
    }
  } else {
    $('.search-overlay-journal-results-none').show()
  }
}
